(function () {
  function init(scope) {
    if (!('IntersectionObserver' in window)) return;

    scope.querySelectorAll('[data-endless-pagination]:not([data-ready])').forEach(function (pager) {
      var section = pager.closest('[data-section-type="filterable"]');
      var grid = section.querySelector('#facets-results');
      var link = pager.querySelector('[data-endless-next]');
      var loader = pager.querySelector('[data-endless-loader]');
      var nextControl = pager.querySelector('[data-endless-next-control]');

      if (!grid || !link) return;

      pager.dataset.ready = true;

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(pager);
        grid.setAttribute('aria-busy', 'true');
        loader.hidden = false;

        fetch(link.href)
          .then(function (response) {
            if (!response.ok) throw new Error();
            return response.text();
          })
          .then(function (html) {
            if (!pager.isConnected) return;

            var page = new DOMParser().parseFromString(html, 'text/html');
            var nextSection = page.querySelector('[data-section-id="' + pager.dataset.sectionId + '"]');
            var nextGrid = nextSection.querySelector('#facets-results');
            var nextLink = nextSection.querySelector('[data-endless-next]');

            while (nextGrid.firstElementChild) grid.appendChild(nextGrid.firstElementChild);

            if (nextLink) {
              link.href = nextLink.href;
              observer.observe(pager);
            }

            pager.closest('.shopify-section').dispatchEvent(
              new CustomEvent('label:section:hasmutated', { bubbles: true })
            );
          })
          .catch(function () {
            nextControl.hidden = false;
          })
          .then(function () {
            grid.removeAttribute('aria-busy');
            loader.hidden = true;
          });
      }, { rootMargin: '600px' });

      observer.observe(pager);
    });
  }

  if (!window.DubblewareEndlessPagination) {
    window.DubblewareEndlessPagination = init;
    window.addEventListener('label:section:hasmutated', function (event) { init(event.target); });
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }

  window.DubblewareEndlessPagination(document);
})();
